import React, { useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

export const RequireAuthRoles = ({ roles, children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const authenticated = useSelector((state) => state.auth.authenticated);
  const authLoading = useSelector((state) => state.auth.loading);
  const user = useSelector((state) => state.auth.user);
  const userRole = user?.role || user?.type;
  const [isRehydrated, setIsRehydrated] = React.useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsRehydrated(true);
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (isRehydrated && !authLoading) {
      if (!authenticated) {
        navigate("/login");
      } else if (!roles.includes(userRole)) {
        navigate("/");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, authLoading, isRehydrated, userRole, location, params]);

  if (!isRehydrated || authLoading) {
    return null;
  }

  return authenticated && roles.includes(userRole) ? children : null;
};
